module.exports = __webpack_public_path__ + "img/SU3M5.95ffae20.jpg";